import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Rates = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("rates");
  const [data, setData] = useState(undefined);
  const [rateCode, setRateCode] = useState("");
  const [rateDesc, setRateDesc] = useState("");
  const [inDirect, setInDirect] = useState(false);
  const [isInActive, setIsInActive] = useState(false);
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyRateCode, setEmptyRateCode] = useState(false);
  const [emptyRateDesc, setEmptyRateDesc] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const handleInActiveCheckboxChange = (event) => {
    setIsInActive(event.target.checked);
  };

  const handleInDirectCheckboxChange = (event) => {
    setInDirect(event.target.checked);
  };

  const handleSave = async (event) => {
    event.preventDefault();

    if (rateCode.length == 0) {
      toast.error("Container Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyRateCode(true);
      setEmptyInput(true);
    } else {
      setEmptyRateCode(false);
    }

    if (rateDesc.length == 0) {
      toast.error("Container Name can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyRateDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyRateDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        rate_code: rateCode,
        rate_description: rateDesc,
        active_status: isInActive ? 1 : 0,
        direct_charge_to_customer_or_not: inDirect ? 1 : 0,
      };
      const duplicate = await data.some((el) => el.RateCode == rateCode);
      if (duplicate !== true) {
        axios
          .post(`${baseUrl}${pageComponent}/store`, inputData, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          })
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This currency code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = {
        rate_code: rateCode,
        rate_description: rateDesc,
        active_status: isInActive ? 1 : 0,
        direct_charge_to_customer_or_not: inDirect ? 1 : 0,
      };
      axios
        .post(
          `${baseUrl}${pageComponent}/update/${selectRowData.rate.id}`,
          inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setRateCode("");
    setRateDesc("");
    setIsInActive(false);
    setInDirect(false);
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.rates);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function setSelectedRow(rowid) {
    console.log(rowid);
    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        console.log(selectRowData.rate);
        setSelectRowData(selectRowData);
        setRateCode(
          selectRowData.rate.rate_code ? selectRowData.rate.rate_code : ""
        );
        setRateDesc(
          selectRowData.rate.rate_description
            ? selectRowData.rate.rate_description
            : ""
        );

        if (selectRowData.rate.active_status == 0) {
          setIsInActive(false);
        } else {
          setIsInActive(true);
        }

        if (selectRowData.rate.direct_charge_to_customer_or_not == 0) {
          setInDirect(false);
        } else {
          setInDirect(true);
        }

        setBtnActive(false);
      });
  }

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${baseUrl}${pageComponent}/destroy/${selectRowData.rate.id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = [
    "rate code",
    "rate description",
    "Rate Group code",
    "Direct Charge to Customer Or Not",
  ];
  const columns = [
    "rate_code",
    "rate_description",
    "rate_group_code",
    "direct_charge_to_customer_or_not",
  ];
  return (
    <Container>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-4 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="rate_code"
                    value={rateCode}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyRateCode == true ? "border-red2" : ""}
                    onChange={(e) => setRateCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="formGroupEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    name="rate_desc"
                    value={rateDesc}
                    className={emptyRateDesc == true ? "border-red2" : ""}
                    onChange={(e) => setRateDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3 " controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                label="In Direct"
                checked={inDirect}
                onChange={handleInDirectCheckboxChange}
              />
              <Form.Check
                type="checkbox"
                label="InActive"
                checked={isInActive}
                onChange={handleInActiveCheckboxChange}
              />
            </Form.Group>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>

                <Button className="ms-3" variant="primary" disabled={btnActive}>
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Rates;
